/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAgreementV2 } from './ServiceAgreementV2';
import {
    ServiceAgreementV2FromJSON,
    ServiceAgreementV2FromJSONTyped,
    ServiceAgreementV2ToJSON,
    ServiceAgreementV2ToJSONTyped,
} from './ServiceAgreementV2';

/**
 * 
 * @export
 * @interface GetServiceAgreementListResponse
 */
export interface GetServiceAgreementListResponse {
    /**
     * 
     * @type {Array<ServiceAgreementV2>}
     * @memberof GetServiceAgreementListResponse
     */
    list?: Array<ServiceAgreementV2>;
}

/**
 * Check if a given object implements the GetServiceAgreementListResponse interface.
 */
export function instanceOfGetServiceAgreementListResponse(value: object): value is GetServiceAgreementListResponse {
    return true;
}

export function GetServiceAgreementListResponseFromJSON(json: any): GetServiceAgreementListResponse {
    return GetServiceAgreementListResponseFromJSONTyped(json, false);
}

export function GetServiceAgreementListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceAgreementListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'list': json['list'] == null ? undefined : ((json['list'] as Array<any>).map(ServiceAgreementV2FromJSON)),
    };
}

export function GetServiceAgreementListResponseToJSON(json: any): GetServiceAgreementListResponse {
    return GetServiceAgreementListResponseToJSONTyped(json, false);
}

export function GetServiceAgreementListResponseToJSONTyped(value?: GetServiceAgreementListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'list': value['list'] == null ? undefined : ((value['list'] as Array<any>).map(ServiceAgreementV2ToJSON)),
    };
}

